import {
  CardContent,
  Divider,
  Button,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import Card from "@material-ui/core/Card/Card";
import Grid from "@material-ui/core/Grid";
import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import ETeramsConditions from "./view/e_terms-conditions";
import MuiLink from "@material-ui/core/Link";
import DocumentSelect from "./view/e_document-select";
import { ticketService } from "../model/_service";
import Alert from "@material-ui/lab/Alert";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  cardContnt: {
    backgroundColor: theme.palette.eBackground.base,
  },
  textFieldsContainer: {
    minHeight: "57vh",
    padding: "2%",
  },
  containers: {
    padding: "0 2%",
  },
  buttonGrid: {
    textAlign: "right",
    margin: "0.4rem 0",
  },
  dividerStyle: {
    width: "100%",
    margin: "1.5rem 0",
    textAlign: "center",
    backgroundColor: theme.palette.eBackground.base,
  },
  nextButton: {
    padding: "3% 20%",
    marginLeft: "1rem",
    marginRight: "3rem",
    color: theme.palette.eWhite.base,
    backgroundColor: theme.palette.ePrimary.base,
    borderRadius: "2rem",
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
  },
  textFieldsContainer: {
    minHeight: "57vh",
    padding: "2%",
  },
  containers: {
    padding: "0 2%",
  },
  buttonGrid: {
    textAlign: "right",
    margin: "0.4rem 0",
  },
  dividerStyle: {
    width: "100%",
    margin: "1.5rem 0",
    textAlign: "center",
    backgroundColor: theme.palette.eBackground.base,
  },
  blueColor: {
    color: theme.palette.ePrimary.base,
  },
  grayColor: {
    color: theme.palette.eRich?.base,
  },
  asterisk: {
    color: theme.palette.eDanger?.dark,
  },
  underLine: {
    textDecoration: "underline",
  },
  attachButton: {
    color: theme.palette.eWhite.base,
    backgroundColor: theme.palette.ePrimary.base,
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
  },
  cancel: {
    color: theme.palette.ePrimary.base,
  },
  moreFiles: {
    color: theme.palette.ePrimary.base,
  },
  uploadDocPaddingBottom: {
    marginBottom: "0.625rem",
    marginTop: "1rem",
    [theme.breakpoints.up("lg")]: {
      padding: "0 10%",
    },
  },
  cancelNextAlign: {
    justifyContent: "right",
    align: "right",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
    },
  },
  alert: {
    marginTop: "1rem"
  },
  greyColor: {
    color: theme?.palette?.eMedium?.base,
  },
  alertText: {
    display: "flex",
    height: "65vh",
    alignItems: "center",
    justifyContent: "center",
  },
  circularLoading:{
    color : theme.palette.eWhite.base
  },
}));

function EUplaodDocuments(props) {
  const {
    name,
    termsAgreedTime,
    setTermsAgreedTime,
    handleClickOpen,
    connectionType,
    connectionTypeCode,
    documentList,
    setDocumentList,
    documentCodeList,
    dropDownData,
    idValue,
    setActiveStep,
    existingCustomer,
    masterDataIdValue,
    masterDataName
  } = props;
  const classes = useStyles();
  const [value, setValue] = useState("");
  const [key, setKey] = useState();
  const signName = existingCustomer=="yes"?masterDataName:name;
  const primaryLanguage = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const summaryReviewLabel = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_SUMMARY_REVIEW
  );
  const labels = useSelector(
    (store) => store?.labels?.data?.getLabels?.E_DOCUMENT_UPLOAD
  );
  const languageCode = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const maxFiles = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.E_UPLOAD_MAX_FILE
  );

  const { t: contentTemp, ready: contentReady } = useTranslation("content-E_UPLOAD_DOCUMENTS");
  const [fileChooserContent, setFileChooserContent] = useState();
  const [termsContent, setTermsContent] = useState();
  const [documentRequireError, setDocumentRequireError] = useState(false);
  const [isDropDownLoading, setIsDropDownLoading] = useState(false);
  const [documentContentList, setDocumentContentList] = useState([]);
  const [documentContentKeyList, setDocumentContentKeyList] = useState([]);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [isLoading, setIsLoading] = useState(false);
  const [isAlertOn, setIsAlertOn] = useState(false);
  const fileTypes = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.E_NCR_FILE_FORMATS
  );
  useEffect(() => {
    if (connectionTypeCode) {
      setValue(connectionType);
      var contentList = contentTemp(
        "E_REQUIRED_DOCUMENTS_" + connectionTypeCode
      );
      setDocumentContentList(contentList?.answer?.split("#"));
      setDocumentContentKeyList(contentList?.question?.split(","));
    }
  }, [connectionTypeCode, contentReady]);

  useEffect(() => {
    if (contentReady) {
      setFileChooserContent(contentTemp("E_UPLOAD_FILES_CONTENT"));
      setTermsContent(contentTemp("E_UPLOAD_FILES_CONTENT"));
    }
  }, [contentReady]);

  const handleClickAlert = () => {
    setIsAlertOn(false);
  };

  const nextHandler = () => {
    let docCount = 0;
    documentList.map((item) => {
      if (
        item?.dropDownCode &&
        item?.dropDownValue &&
        item?.files?.length > 0
      ) {
        docCount++;
      }
    });
    if (docCount === documentList?.length) {
      setIsLoading(true);
      setAlertSeverity("info");
      setAlertMsg(contentTemp("E_DOCUMENT_UPLOAD_LOADING_MSG")?.answer);
      setIsAlertOn(true);
      let tempArray = [];
      let count = 0;
      if (documentList.length !== 0) {
        documentList.map((item) => {
          if (item && item.files && item.files.length !== 0) {
            item.files.map((element) => {
              element.seq = "" + count;
              count = Number(count) + 1;
              element.attachmentFor = item.dropDownCode;
              element.action = "ADD_UPDATE"
              return tempArray.push(element);
            });
          }
        });
      }
      let requestData = {
        action: "DOCUMENT_UPLOAD",
        languageCode: languageCode,
        documentDetails: {
          applicationId: existingCustomer=="yes"?masterDataIdValue:idValue,
          documentCodeList: documentCodeList,
          documentList: tempArray,
        },
      };
      ticketService
        .newConnectionRequestData(JSON.stringify(requestData))
        .then((response) => {
          if (response?.data?.createNewConnectionReqTicket?.isOk) {
            setIsAlertOn(false);
            setActiveStep(3);
            setIsLoading(false);
          } else {
            setAlertSeverity("error");
            setAlertMsg(contentTemp("E_DOCUMENT_UPLOAD_ERROR_MSG")?.answer);
            setIsAlertOn(true);
            setIsLoading(false);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          setAlertSeverity("error");
          setAlertMsg(contentTemp("E_DOCUMENT_UPLOAD_ERROR_MSG")?.answer);
          setIsAlertOn(true);
        });
    } else {
      setDocumentRequireError(true);
    }
  };

  return (
    <>
      {isDropDownLoading ? (
        <Grid className={classes.alertText}>
          <CircularProgress className={classes.blueColor} />
        </Grid>
      ) : (
        <Grid container direction="column">
          <Grid item>
            <Typography variant="subtitle1" className={classes.blueColor}>
              <b>{labels?.E_DOCUMENT_UPLOAD_TITLE}</b>
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="subtitle2" className={classes.blueColor}>
              {contentTemp("E_UPLOAD_DOCUMENT_DESCRIPTION")?.answer?.replace(
                "****",
                connectionType
              )}
            </Typography>
          </Grid>
          <Grid item className={classes.uploadDocPaddingBottom}>
            <Card className={classes.cardContnt} elevation={0}>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      className={classes.blueColor}
                    >
                      <b>{connectionType}</b>
                    </Typography>
                  </Grid>
                  {documentContentList?.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <Typography
                        variant="subtitle2"
                        className={classes.grayColor}
                      >
                        {item}
                        <span className={classes.asterisk}>*</span>
                      </Typography>
                      <DocumentSelect
                        isDropDown={true}
                        index={index}
                        dropDownData={dropDownData}
                        fileArray={documentList}
                        setFileArray={setDocumentList}
                        fileTypes={fileTypes}
                        documentRequireError={documentRequireError}
                        content={fileChooserContent}
                        docKey={documentContentKeyList[index]}
                        docValue={item}
                        fileNumber={
                          Number(maxFiles) - (documentList[index]?.files?.length ? documentList[index]?.files?.length : 0)
                        }
                      />
                    </Grid>
                  ))}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Divider className={classes.dividerStyle}></Divider>
          <Grid item>
            <ETeramsConditions
              content={termsContent}
              userName={signName}
              termsAgreedTime={termsAgreedTime}
              setTermsAgreedTime={setTermsAgreedTime}
            />
          </Grid>
          {isAlertOn && (
            <Grid item className={classes.alert}>
              <Alert severity={alertSeverity} onClose={handleClickAlert}>
                {alertMsg}
              </Alert>
            </Grid>
          )}
          <Divider className={classes.dividerStyle}></Divider>
          <Grid
            container
            spacing={0}
            alignItems="center"
            justify="flex-end"
            className={[classes.containers, classes.cancelNextAlign]}
          >
            <Grid item>
              <MuiLink
                component="button"
                onClick={() => {
                  handleClickOpen();
                }}
                underline="hover"
                className={classes.cancel}
              >
                <Typography variant="subtitle2">
                  <b>{summaryReviewLabel?.E_CANCEL_LABEL}</b>
                </Typography>
              </MuiLink>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                className={classes.nextButton}
                onClick={nextHandler}
                disabled={termsAgreedTime == "" ? true : false}
              >
                {labels?.E_UPLOAD_PROCEED}
                &nbsp;{isLoading && <CircularProgress className={classes.circularLoading} size={14}/>}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default EUplaodDocuments;
